export default function Dropbox({ className = "w2rem ma" }) {
	return <svg className={className} viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.70076 0.320312L0.478516 4.91332L7.70076 9.50633L14.9242 4.91332L22.1465 9.50633L29.3687 4.91332L22.1465 0.320312L14.9242 4.91332L7.70076 0.320312Z" fill="#26BCFC"></path>
		<path d="M7.70076 18.6925L0.478516 14.0994L7.70076 9.50633L14.9242 14.0994L7.70076 18.6925Z" fill="#26BCFC"></path>
		<path d="M14.9242 14.0994L22.1465 9.50633L29.3687 14.0994L22.1465 18.6925L14.9242 14.0994Z" fill="#26BCFC"></path>
		<path d="M14.9242 24.8164L7.70077 20.2234L14.9242 15.6304L22.1465 20.2234L14.9242 24.8164Z" fill="#26BCFC"></path>
	</svg>
}
